import AxiosInstance from "../services/networkServices";

export const saveTncPolicyData = (data) =>
  AxiosInstance.post(`/api/admin/add-policy`, data);

export const getTncPolicyData = (type) =>
  AxiosInstance.get(`/api/admin/list-policy/${type}`);

export const sendBroadcast = (data) =>
  AxiosInstance.post(`/api/notification/send-notification`, data);
